/**
 * Product exclusion rules for Intruder, Motion Plus, and Line Crossing.
 *
 * When `allowConcurrentLineCrossingIntruderProducts` is false (legacy):
 * all three products are mutually exclusive.
 *
 * When true: only Intruder and Motion Plus are mutually exclusive; Line Crossing
 * can run with either product.
 */
export type TrioSelectedGroupsSlice = {
  intruder: { selected: boolean; disabled?: boolean };
  motionPlus: { selected: boolean };
  lineCrossing: { selected: boolean };
};

export function trioActiveProductCount(
  selectedGroups: TrioSelectedGroupsSlice
): number {
  return (
    Number(!!selectedGroups.intruder.selected) +
    Number(!!selectedGroups.motionPlus.selected) +
    Number(!!selectedGroups.lineCrossing.selected)
  );
}

export function trioMutualExclusionRecoveryMode(
  selectedGroups: TrioSelectedGroupsSlice,
  allowConcurrentLineCrossingIntruderProducts = false
): boolean {
  if (allowConcurrentLineCrossingIntruderProducts) {
    return (
      selectedGroups.intruder.selected && selectedGroups.motionPlus.selected
    );
  }

  return trioActiveProductCount(selectedGroups) >= 2;
}

/** Same rule using API-derived booleans (before selectedGroups is fully built). */
export function trioMutualExclusionRecoveryModeFromApiFlags(
  baseIntruderActive: boolean,
  motionPlusActive: boolean,
  lineCrossingActive: boolean,
  allowConcurrentLineCrossingIntruderProducts = false
): boolean {
  if (allowConcurrentLineCrossingIntruderProducts) {
    return baseIntruderActive && motionPlusActive;
  }

  const activeCount =
    Number(baseIntruderActive) +
    Number(motionPlusActive) +
    Number(lineCrossingActive);
  return activeCount >= 2;
}

export function shouldDisableIntruderForActiveProducts(
  motionPlusActive: boolean,
  lineCrossingActive: boolean,
  allowConcurrentLineCrossingIntruderProducts: boolean
): boolean {
  return (
    motionPlusActive ||
    (!allowConcurrentLineCrossingIntruderProducts && lineCrossingActive)
  );
}
